import React from 'react'
import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink.tsx'
import { IEcommerceAnswerSchema } from '../../types'
import Rating from '../components/Rating'
import style from './CardHeader.module.scss'
import commonStyle from '../common.module.scss'
import { unescapeTags } from '@aytm/lib/common/func'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import ecoLeafIcon from '../img/ecoLeaf.png'
import infoCircleIcon from '../img/infoCircle.svg'

type cardHeaderProps = {
  schema: IEcommerceAnswerSchema
}
const CardHeader = ({ schema }: cardHeaderProps) => {
  const { t } = useSurveyLocale()
  return (
    <div className={style.cardHeader}>
      <div className={style.cardHeaderTop}>
        <div className={style.distributor}>
          <div className={style.distributorInfo}>
            <EmptyLink>
              <p>{unescapeTags(schema.sub_title)}</p>
            </EmptyLink>
          </div>
        </div>
        <EmptyLink>
          <div className={style.stars}>
            <span className={style.rating}>{schema.rating}</span>
            <Rating size="small" rating={schema.rating} />
            <span className={style.review}>{`(${schema.reviews})`}</span>
          </div>
        </EmptyLink>
      </div>
      <span className={style.title} dangerouslySetInnerHTML={{ __html: schema.text }}></span>
      <div className={style.labels}>
        {schema.amazon_choice ? (
          <div className={commonStyle.amazonChoiceBadge}>{t('questions', 'ec', 'amazon', 'amazonsChoice')}</div>
        ) : schema.best_seller ? (
          <div className={commonStyle.bestSellerBadge}>{t('questions', 'ec', 'amazon', 'bestSeller')}</div>
        ) : schema.overal_pick ? (
          <div className={commonStyle.overalPickBadge}>
            {t('questions', 'ec', 'amazon', 'overallPick')}
            <img src={infoCircleIcon} alt="" />
          </div>
        ) : (
          ''
        )}
        {schema.green_label ? (
          <span className={style.greenLabel} dangerouslySetInnerHTML={{ __html: schema.green_label }} />
        ) : (
          ''
        )}
        {schema.eco_label ? (
          <EmptyLink>
            <span className={commonStyle.ecoLabel}>
              <img src={ecoLeafIcon} width={18} height={18} alt="" />
              <span className={commonStyle.arrowDown}>
                <span dangerouslySetInnerHTML={{ __html: schema.eco_label }} /> <i />
              </span>
            </span>
          </EmptyLink>
        ) : (
          ''
        )}
        {schema.prime ? <i className={`${commonStyle['prime' + schema.prime]} ${commonStyle.primeLabel}`} /> : ''}
      </div>
      <span className={style.bought}>{unescapeTags(schema.bought)}</span>
    </div>
  )
}

export default CardHeader
